import React from 'react';
import { servicesData, IconMap } from './data';

const ServicesSection: React.FC = () => {
    return (
        <section id="services" className="py-16 md:py-24 relative z-10">
            <div className="container mx-auto px-4 md:px-6">
                {/* Header */}
                <div className="text-center mb-12 md:mb-16">
                    <h2 className="text-3xl md:text-4xl lg:text-6xl font-serif font-black mb-4 md:mb-6 text-white leading-tight">
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400">15+ AI Services</span> at Your Fingertips
                    </h2>
                    <p className="text-base md:text-lg text-primary-200/80 max-w-2xl mx-auto font-sans leading-relaxed px-2 md:px-0">
                        From Vedic astrology to tarot, numerology to palm reading, explore our comprehensive spiritual guidance powered by ancient wisdom and modern AI.
                    </p>
                </div>

                {/* 2-Column Service Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-5 max-w-7xl mx-auto">
                    {servicesData.map((service, i) => {
                        const Icon = IconMap[service.iconName];
                        return (
                            <div
                                key={i}
                                className="group relative bg-white/[0.06] backdrop-blur-sm border border-white/10 rounded-2xl p-5 md:p-6 hover:bg-white/[0.10] hover:border-purple-400/40 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/10"
                            >
                                <div className="flex items-start gap-4 md:gap-5">
                                    {/* Icon Container */}
                                    <div className={`flex-shrink-0 w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br ${service.gradient} rounded-xl flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-300`}>
                                        <div className="text-white">
                                            {Icon && <Icon className="w-6 h-6 md:w-7 md:h-7" />}
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="flex-1 min-w-0">
                                        {/* Title & Subtitle */}
                                        <h3 className="text-base md:text-lg font-bold text-white font-sans mb-0.5 leading-tight">
                                            {service.name}
                                        </h3>
                                        <p className="text-xs text-purple-300/70 font-medium mb-2">
                                            {service.subtitle}
                                        </p>

                                        {/* Description */}
                                        <p className="text-sm text-purple-200/70 leading-relaxed mb-3">
                                            {service.desc}
                                        </p>

                                        {/* Features as inline tags */}
                                        <div className="flex flex-wrap gap-1.5">
                                            {service.features.map((feature, j) => (
                                                <span
                                                    key={j}
                                                    className="px-2 py-0.5 rounded-full text-[10px] md:text-xs font-medium bg-white/10 text-purple-200/90 border border-white/10"
                                                >
                                                    {feature}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;
